<template>
  <el-container>
    <!-- 顶部 -->
    <el-header>
      <span>{{ settings.platformName }}</span>
    </el-header>

    <!-- 下面部分 -->
    <el-container>
      <!-- 左侧菜单栏 -->
      <el-aside width="160px">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          router
          unique-opened>
          <template v-for="route in menuRoutes">
            <el-submenu v-if="route.children" :index="route.path" :key="route.path">
              <template slot="title">
                <i :class="route.meta.icon"></i>
                <span>{{ route.meta.title }}</span>
              </template>
              <el-menu-item
                v-for="child in route.children"
                :key="child.path"
                :index="'/home/' + route.path + '/' + child.path"
                style="padding-left: 40px;">
                <span slot="title">{{ child.meta.title }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="'/home/' + route.path" :key="route.path" style="padding-left: 20px;">
              <i :class="route.meta.icon"></i>
              <span slot="title">{{ route.meta.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <!-- 右侧内容区域 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>

    <!-- 右下角提示窗 -->
    <div v-if="hintMessage" class="hint-container">
      <div>
        <span>{{ data.withdrawal ? `提款：用户 ${data.withdrawal.user.account} 申请提款 ${data.withdrawal.amount} ${data.withdrawal.type}，状态：${data.withdrawal.status === 0 ? '待处理' : '已处理'}` : '' }}</span>

      </div>
      <div>
        <span>{{ data.deposit ? `存款：用户 ${data.deposit.user.account} 存入 ${data.deposit.amount} ${data.deposit.type}，状态：${data.deposit.status === 0 ? '待处理' : '已处理'}` : '' }}</span>
      </div>
    </div>
  </el-container>
</template>

<script>
import settings from '@/config/settings';
import { getHintList } from '@/api/hint';

export default {
  name: 'Home',
  data() {
    return {
      settings: settings,
      hintMessage: false,
      hintInterval: null,
      data:{}
    };
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    menuRoutes() {
      return this.$router.options.routes.find(route => route.path === '/home').children;
    }
  },
  methods: {
    speak(text) {
      if ('speechSynthesis' in window) {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = 'zh-CN';
        speechSynthesis.speak(utterance);
      } else {
        console.error('您的浏览器不支持文字转语音功能');
      }
    },
    async fetchHint() {
    try {
      const response = await getHintList();
      if (response.data) {
        this.hintMessage = true;
        this.data = response.data;
        let message = '';

        if (this.data.withdrawal) {
          message += `你有提现未处理`;
        }
        if (this.data.deposit) {
          message += `你有存款未处理`;
        }

        if (message) {
          this.hintMessage = message;
          this.speak(this.hintMessage);
        }
      }
    } catch (error) {
      console.error('获取提示信息失败', error);
    }
  },
    startHintInterval() {
      this.hintInterval = setInterval(() => {
        this.fetchHint();
      }, 60000); // 每分钟获取一次提示信息
    }
  },
  mounted() {
    this.fetchHint();
    this.startHintInterval();
  },
  beforeDestroy() {
    if (this.hintInterval) {
      clearInterval(this.hintInterval);
    }
  }
}
</script>

<style scoped>
.el-header {
  background-color: #409EFF;
  color: #fff;
  line-height: 60px;
}
.el-aside {
  background-color: #545c64;
}
.el-main {
  background-color: #f0f2f5;
}
.el-menu-item.is-active {
  background-color: #d68a33 !important;
  color: #fff !important;
}
.hint-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  background-color: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 2000;
}
</style>